import React, { useState, useEffect } from 'react';
import assetUrl from '../../utils/assetUrl';

const EveOverview = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <section style={{
      padding: '70px 20px 30px 20px',
      backgroundColor: '#000',
      color: '#fff',
      textAlign: 'center',
      position: 'relative'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '60px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{ flex: 1, width: '100%', position: 'relative', zIndex: 1 }}>
          <h2 id="overview-title" style={{
            fontSize: 'clamp(2rem, 5vw, 4rem)',
            marginBottom: '60px',
            fontWeight: '700',
            letterSpacing: '0.1em'
          }}>OVERVIEW</h2>

          <table style={{
            borderCollapse: 'collapse',
            width: '100%',
            backgroundColor: 'transparent'
          }}>
          <tbody>
            <tr style={{
              borderBottom: 'none',
              backgroundImage: 'linear-gradient(to right, transparent, white 5%, white 95%, transparent)',
              backgroundPosition: 'bottom',
              backgroundSize: '100% 1px',
              backgroundRepeat: 'no-repeat'
            }}>
              <td style={{
                padding: '20px',
                fontWeight: '600',
                width: '40%'
              }}>HEIGHT</td>
              <td style={{ padding: '15px' }}>27.5 m / 90.2 ft</td>
            </tr>
            <tr style={{
              borderBottom: 'none',
              backgroundImage: 'linear-gradient(to right, transparent, white 5%, white 95%, transparent)',
              backgroundPosition: 'bottom',
              backgroundSize: '100% 1px',
              backgroundRepeat: 'no-repeat'
            }}>
              <td style={{
                padding: '20px',
                fontWeight: '600'
              }}>DIAMETER</td>
              <td style={{ padding: '15px' }}>1.5 m / 4.9 ft</td>
            </tr>
            <tr style={{
              borderBottom: 'none',
              backgroundImage: 'linear-gradient(to right, transparent, white 5%, white 95%, transparent)',
              backgroundPosition: 'bottom',
              backgroundSize: '100% 1px',
              backgroundRepeat: 'no-repeat'
            }}>
              <td style={{
                padding: '20px',
                fontWeight: '600'
              }}>MASS</td>
              <td style={{ padding: '15px' }}>32T / 70,547 lbs</td>
            </tr>
            <tr style={{
              borderBottom: 'none',
              backgroundImage: 'linear-gradient(to right, transparent, white 5%, white 95%, transparent)',
              backgroundPosition: 'bottom',
              backgroundSize: '100% 1px',
              backgroundRepeat: 'no-repeat'
            }}>
              <td style={{
                padding: '20px',
                fontWeight: '600'
              }}>PAYLOAD TO LEO</td>
              <td style={{ padding: '15px' }}>1500 kg / 3,307 lbs</td>
            </tr>
            <tr style={{
              borderBottom: 'none',
              backgroundImage: 'linear-gradient(to right, transparent, white 5%, white 95%, transparent)',
              backgroundPosition: 'bottom',
              backgroundSize: '100% 1px',
              backgroundRepeat: 'no-repeat'
            }}>
              <td style={{
                padding: '20px',
                fontWeight: '600'
              }}>PAYLOAD TO GSO</td>
              <td style={{ padding: '15px' }}>750 kg / 1,653 lbs</td>
            </tr>
          </tbody>
        </table>
        </div>

        <img
          className="eve-overview-image"
          src={assetUrl('full-stack-legs-up-v3.png')}
          alt="Eve Overview"
          style={{
            position: 'absolute',
            width: '100%',
            maxWidth: '800px',
            height: 'auto',
            borderRadius: '8px',
            transform: `translateY(-${scrollY * 0.53}px)`,
            left: '50%',
            marginLeft: '-400px',
            top: '300px',
            pointerEvents: 'none',
            zIndex: 3
          }}
        />
      </div>
    </section>
  );
};

export default EveOverview;